import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { GastroService } from '../gastro.service';
import { PathologyService } from '../pathology.service';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { ExamsService } from '../exams.service';
import { PatientsService } from '../patients.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-labresults',
    templateUrl: './labresults.component.html',
    styleUrls: ['./labresults.component.scss'],
    standalone: false
})
export class LabresultsComponent implements OnInit {
  showInventorySearch: boolean = false;
  invStartdate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  invEnddate: Date = new Date();
  searchedInventories: any[] = [];

  status: string = 'Needs_payer';
  lab = '';
  startdate: Date  = new Date(new Date().setMonth(new Date().getMonth() - 1));
  enddate: Date = new Date();
  doctor: number = null;
  labResults: any[];
  reportToShow: number;
  messengerReportID: number = null;
  pdfMessengerID: number = null;
  activeInventories: any[];
  completedInventories: any[];
  // Server-side pagination for the active inventories list.
  invPage: number = 1;
  invPageSize: number = 25;
  invTotal: number = 0;
  get invTotalPages(): number {
    return Math.max(1, Math.ceil(this.invTotal / this.invPageSize));
  }
  // Selected rows persist across pages; keyed by row id and holding the row so
  // off-page selections keep their pathology/AutoIndex for the bulk actions.
  selectedRows = new Map<any, any>();
  // Loading flags for the lab results / inventory list spinners.
  resLoading: boolean = false;
  invLoading: boolean = false;
  compLoading: boolean = false;
  // Server-side pagination for the lab results list.
  resPage: number = 1;
  resPageSize: number = 25;
  resTotal: number = 0;
  get resTotalPages(): number {
    return Math.max(1, Math.ceil(this.resTotal / this.resPageSize));
  }
  // Server-side pagination for the completed (old) inventories list.
  compPage: number = 1;
  compPageSize: number = 25;
  compTotal: number = 0;
  get compTotalPages(): number {
    return Math.max(1, Math.ceil(this.compTotal / this.compPageSize));
  }
  inventorySigned = false;
  pdf:any = null;
  mode: string = 'results'; // 'results' | 'reports'

  constructor(
    public loginService: LoginService,
    private gastroService: GastroService,
    private sanitizer: DomSanitizer,
    private exServ: ExamsService,
    private pathologyService: PathologyService,
    private patientsService: PatientsService,
    private rt: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loginService.loginMissing();
    if(this.loginService.userType == 'doctor')
      this.doctor = this.loginService.UID;

    this.route.queryParams.subscribe(params => {
      const unassignedLabReports = Number(params['unassignedLabReports'] || 0);
      if (unassignedLabReports > 0) {
        this.status = 'Needs_Assignment';
      } else {
        switch(this.loginService.userType){
          case 'nurse':
            this.status = 'Awaiting_transfer';
            break;
          case 'doctor':
            this.status = 'Needs_Analysis';
            break;
          default:
            this.status = 'Needs_Assignment';
        }
      }
      this.getLabResults();
      if(this.loginService.userType != 'doctor')
        this.getActiveInventories();
    });
  }

  searchInventorySheets() {
    this.pathologyService.getCompletedInventories(this.invStartdate, this.invEnddate).subscribe((data: any[]) => {
      this.searchedInventories = data;
    });
  }

  getLabResults(resetPage = true) {
    if (resetPage) {
      this.resPage = 1;
      // A filter change starts a new selection; paging (resetPage=false) keeps it.
      this.selectedRows.clear();
    }
    if (this.status == "Messenger_reports") {
      return;
    }
    if (this.status == "Old_reports") {
      this.getInventoryHistory();
      return;
    }
    this.labResults = [];
    this.resTotal = 0;
    if (!this.status || (!this.lab && this.status == "Awaiting_transfer")) {
      return;
    }

    this.resLoading = true;
    this.gastroService
      .labResults(
        this.status,
        this.lab,
        this.doctor,
        this.resPage,
        this.resPageSize,
      )
      .subscribe(
        (data: any[]) => {
          this.labResults = data;
          this.applySelection(data);
          this.resTotal =
            data && data.length ? Number(data[0]["Total"]) || data.length : 0;
          this.resLoading = false;
          if (this.status == "All" && data.length > 0) {
            if (!data[0].PathologyID) {
              this.status = "Needs_Assignment";
            } else {
              if (!data[0].Analyzed) {
                this.status = "Needs_Analysis";
              }
            }
          }
        },
        (error) => {
          this.resLoading = false;
          console.error("Error fetching lab results:", error);
        },
      );
  }

  goExam(examid,pid) {
    this.exServ.goExamNoPrelaod(examid,pid, this.status == 'Needs_payer');
  }

  makeMessengerReport(){
    let selected = []
    // Iterate the persisted selection so rows picked on other pages are included.
    for (let result of this.selectedRows.values()) {
      if (result.pathology) {
        for(let pathology of result.pathology){
          selected.push(pathology.AutoIndex);
        }
      }
    }
    if (selected.length > 0) {
        this.pathologyService.makeMessengerReport(selected, this.lab).subscribe((data) => {
          this.inventorySigned = false;
          this.messengerReportID = data['reportId'];
        });
      }
  }

  getActiveInventories(){
    // Clear first so a failed request can't leave the previous page's rows on screen.
    this.activeInventories = [];
    this.invTotal = 0;
    this.invLoading = true;
    this.pathologyService.getActiveInventories(this.invPage, this.invPageSize).subscribe((data:any[]) => {
      this.activeInventories = data;
      this.invLoading = false;
      this.invTotal = data && data.length ? Number(data[0]['Total']) || data.length : 0;
      if( this.activeInventories && this.activeInventories.length > 0){
        if(this.loginService.userType == 'secretary')
          this.status = 'Messenger_reports';
        if(this.loginService.userType == 'nurse'){
          // UnsignedByNurse counts the whole result set, so paging can't hide an unsigned inventory.
          if(Number(data[0]['UnsignedByNurse']) > 0)
            this.status = 'Messenger_reports';
        }
      }

    }, () => {
      this.invLoading = false;
    });
  }

  invNextPage(){
    if(this.invPage < this.invTotalPages){
      this.invPage++;
      this.getActiveInventories();
    }
  }

  invPrevPage(){
    if(this.invPage > 1){
      this.invPage--;
      this.getActiveInventories();
    }
  }

  getInventoryHistory(resetPage = true){
    if(resetPage)
      this.compPage = 1;
    // Clear first so a failed request can't leave the previous date range's rows on screen.
    this.completedInventories = [];
    this.compTotal = 0;
    this.compLoading = true;
    this.pathologyService.getCompletedInventories(this.startdate, this.enddate, this.compPage, this.compPageSize).subscribe((data:any[]) => {
      this.completedInventories = data;
      this.compTotal = data && data.length ? Number(data[0]['Total']) || data.length : 0;
      this.compLoading = false;
    }, () => {
      this.compLoading = false;
    });
  }

  // labresults rows key off AutoIndex; Awaiting_transfer rows key off ExamID.
  rowKey(row: any){
    return row.AutoIndex != null ? row.AutoIndex : row.ExamID;
  }

  toggleSelected(row: any){
    const key = this.rowKey(row);
    if(row.selected)
      this.selectedRows.set(key, row);
    else
      this.selectedRows.delete(key);
  }

  // Re-tick checkboxes for rows selected on other pages, and refresh the stored row.
  private applySelection(rows: any[]){
    for(const row of rows || []){
      const key = this.rowKey(row);
      if(this.selectedRows.has(key)){
        row.selected = true;
        this.selectedRows.set(key, row);
      }
    }
  }

  // Statuses whose backend query is paginated; others still return the full list.
  isPaginatedStatus(){
    return ['Awaiting_Lab_Results', 'Needs_Analysis', 'Needs_Assignment', 'Awaiting_transfer'].includes(this.status);
  }

  resNextPage(){
    if(this.resPage < this.resTotalPages){
      this.resPage++;
      this.getLabResults(false);
    }
  }

  resPrevPage(){
    if(this.resPage > 1){
      this.resPage--;
      this.getLabResults(false);
    }
  }

  compNextPage(){
    if(this.compPage < this.compTotalPages){
      this.compPage++;
      this.getInventoryHistory(false);
    }
  }

  compPrevPage(){
    if(this.compPage > 1){
      this.compPage--;
      this.getInventoryHistory(false);
    }
  }

  openInventory(inventory){
    this.inventorySigned = false;
    if((this.loginService.userType == 'nurse' && inventory.SigningNurse) ||
      (this.loginService.userType == 'secretary' && inventory.SigningSecretary)) {
      this.inventorySigned = true;
    }
    this.messengerReportID = inventory.AutoIndex;
  }

  openOldInventory(inventory){
    this.pdfMessengerID = inventory.AutoIndex;
  }

  showReport(report:any){
    if(report && report.ReceptionDate)
      this.reportToShow = report.AutoIndex;
  }

  reportView(){
    if(this.reportToShow || this.pdf || this.pdfMessengerID)
      return true;
    return false;
  }

  closeWPDF(pdf){
    if(this.messengerReportID){
      this.lab = '';
      this.labResults = [];
      this.getActiveInventories();
    }

    this.messengerReportID = null;
    this.reportToShow = null;
    this.pdfMessengerID = null;
    this.pdf = pdf;
  }

  reportSelected(){//returns true if nures selected 1 or more checkboxes (across all pages)
    if (this.selectedRows.size > 0) {
      return true;
    }
    return false;
  }

  goPatient(pid){
    this.patientsService.getPatient(pid, (s) => {
      if (s) this.rt.navigate(["/exams"], { state: { data: this.patientsService.currentPatient } });
    });
  }

  getPathNotes(result){
    //loginService.userType === 'nurse' && status == 'Awaiting_transfer' && lab ? getPathNotes(result):'Open Lab Results'
    if( this.loginService.userType != 'nurse' || this.status != 'Awaiting_transfer' || ! this.lab){
      if(this.status != 'Needs_Analysis' && this.status != 'Needs_Assignment')
        return '';
      return  this.translate.instant('GUI.gastro.lab_results.tooltips.open_lab_results');;
    }
    let txt = '';
    let i=1;
    for(let p of result.pathology){
      txt += `${i++}) ${p.Type} ${p.Comments} Barcode:${p.BarCode}` + ' ';
    }
    return txt;
  }

  getNeededSignatures(inventory: any): string {
    const roles: string[] = [];
    if (!inventory.SigningNurse) {
      roles.push(
        this.translate.instant("GUI.gastro.lab_results.signatures.roles.nurse"),
      );
    }
    if (!inventory.SigningSecretary) {
      roles.push(
        this.translate.instant(
          "GUI.gastro.lab_results.signatures.roles.secretary",
        ),
      );
    }
    if (!inventory.LabMessenger) {
      roles.push(
        this.translate.instant(
          "GUI.gastro.lab_results.signatures.roles.messenger",
        ),
      );
    }
    if (roles.length === 0) {
      return "";
    }

    const roleList = roles.join(
      this.translate.instant("GUI.gastro.lab_results.signatures.and"),
    );
    const key =
      roles.length > 1
        ? "GUI.gastro.lab_results.signatures.needs_signatures"
        : "GUI.gastro.lab_results.signatures.needs_signature";
    return this.translate.instant(key, { roles: roleList });
  }

  markAsReviewed(){//send request for each selected lab result to mark as reviewed (across all pages)
    let ct = 0;
    const rows = Array.from(this.selectedRows.values());
    let totalSelected = rows.length;

    if (totalSelected === 0) {
      return; // No items selected
    }

    for (const result of rows) {
      this.pathologyService.markAsReviewed(result.AutoIndex).subscribe((data) => {
        ct++;
        if(ct == totalSelected)
          this.getLabResults();
      },(error) => {
        ct++;
        console.error('Error marking as reviewed:', result.AutoIndex, error);
      });
    }
  }
}
